module.exports = __webpack_public_path__ + "yeni karadeniz inşaat 1.jpg?7d7313e43c80117c3c35a5eb2bcc941a";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni karadeniz inşaat 1.jpg
// module id = 378
// module chunks = 0